import Immutable from 'immutable';

// constants
import { ACCEPT_TRADE_OFFER, FETCH_TRADE_OFFERS, REJECT_TRADE_OFFER, SEND_MESSAGE, CANCEL_TRADE_REQUEST } from '../constants/tradeOffersTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { callbackHandler, mergeObject } from '../lib/mapReducerHelpers';

const removeReceivedTrade = (map, action) => {
  const receivedTrades = map.getIn(['data', 'receivedTrades']);

  if (receivedTrades && receivedTrades.size > 0) {
    const filteredReceivedTrades = receivedTrades.filter((receivedTrade) => receivedTrade.get('id') !== action.payload.id);

    map.setIn(['data', 'receivedTrades'], filteredReceivedTrades);
  }
};

const removeRequestedTrade = (map, action) => {
  const requestedTrades = map.getIn(['data', 'requestedTrades']);

  if (!!requestedTrades && requestedTrades.size > 0) {
    const filteredRequestedTrades = requestedTrades.filter((requestedTrade) => requestedTrade.get('id') !== action.payload.id);

    map.setIn(['data', 'requestedTrades'], filteredRequestedTrades);
  }
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case SEND_MESSAGE:            return httpReducer(state, action);
    case FETCH_TRADE_OFFERS:      return httpReducer(state, action, callbackHandler(mergeObject));
    case ACCEPT_TRADE_OFFER:      return httpReducer(state, action, removeReceivedTrade);
    case REJECT_TRADE_OFFER:      return httpReducer(state, action, removeReceivedTrade);
    case CANCEL_TRADE_REQUEST:    return httpReducer(state, action, removeRequestedTrade);
    default:                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/tradeOffers.js